import { DateTime } from 'luxon'

const parseEveTimestamp = (timestamp: string): DateTime =>
  DateTime.fromFormat(timestamp, 'yyyy.MM.dd HH:mm', { zone: 'UTC' })

export { parseEveTimestamp }
